import { FC } from "react";

import { SKUPageContentTabType, SKUPageContentUniqueTab } from "@/data/types";

import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";
import { UniqueTabContent } from "./unique-tab/unique-tab-content";
import { UniqueTabProvider } from "./unique-tab/unique-tab-context";
import { UniqueTabHeader } from "./unique-tab/unique-tab-header";
import { UniqueTabSettings } from "./unique-tab/unique-tab-settings";

type Props = {
  index: number;
  options: SKUPageContentUniqueTab["options"];
  data: SKUPageContentUniqueTab["data"];
};

export const CMSUniqueTab: FC<Props> = ({ index, options, data }) => (
  <CMSTabProvider tabType={SKUPageContentTabType.UNIQUE_TAB} tabIndex={index}>
    <CMSTab options={options}>
      <UniqueTabProvider options={options} data={data}>
        <div className="space-y-6">
          <UniqueTabHeader />
          <UniqueTabContent />
          <UniqueTabSettings />
        </div>
      </UniqueTabProvider>
    </CMSTab>
  </CMSTabProvider>
);
